import { ChangeDetectorRef, Component, OnInit } from "@angular/core";
import { BaseFormComponent } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-form.component";
import { SelectorService } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/selector.service";
import { takeUntil } from "rxjs/operators";
import { ReviewFilter } from "../models/review-filter";
import { ReviewReportModel } from "./filter-name.model";

@Component({
  selector: "ngx-filter-name",
  templateUrl: "./filter-name.component.html",
  styleUrls: ["./filter-name.component.scss"],
})
export class FilterNameComponent extends BaseFormComponent<ReviewReportModel> implements OnInit {
  reviewFilter: ReviewFilter;
  constructor(protected selectorService: SelectorService, protected cd: ChangeDetectorRef) {
    super(selectorService, cd);
  }
  async ngOnInit() {
    this.apiName = "ReviewReport";
    this.areaName = "General";
    this.label = this.translate("ClientApp.Review.FilterName.ReviewReport");
    super.ngOnInit();
  }
  setdefault() {
    this.model.DataValue = JSON.stringify(this.reviewFilter);
    this.model.ReportKey = this.reviewFilter.ReportKey;
  }
  saveData() {
    try {
      if (!this.isSaving) {
        if (this.isValid()) {
          this.beforupdate();
          this.sts.showToast("info", "", this.translate("ClientApp.Review.FilterName.SavingChanges"));
          this.isSaving = true;
          this.isSaved = false;
          if (this.isNewRow || !this.id) {
            this.httpCommonService
              .create(this.apiName + "/SaveData", this.getDataFromFormGroup())
              .pipe(takeUntil(this.ngUnsubscribe))
              .subscribe(
                (row) => this.saveSuccessHelper(row),
                (error) => this.saveFailedHelper(error)
              );
          } else {
            this.httpCommonService
              .update(this.apiName, this.getDataFromFormGroup())
              .pipe(takeUntil(this.ngUnsubscribe))
              .subscribe(
                (response) => this.saveSuccessHelper(),
                (error) => this.saveFailedHelper(error)
              );
          }
        } else {
          this.selectorService.submitted$.next(this.submitted);
        }
      } else {
        this.selectorService.submitted$.next(this.submitted);
      }
    } catch (e) {
      this.saveFailedHelper(e);
    }
  }
}
